import { faBookmark } from '@fortawesome/free-regular-svg-icons';
import { faMinus, faPlus } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import AppIcon from 'components/common/AppIcon/AppIcon';
import Button from 'components/common/Button';
import DatePicker from 'components/common/DatePicker';
import IndexedTextInput from 'components/common/IndexedTextInput';
import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { colors } from 'styles/shared';




const SearchContainerRow = styled.div`
  width: 113.8rem;
  height: 9rem;
  padding: 2rem 2.4rem 2rem 2.9rem;
  display: flex;


  @media (max-width: 1440px) {
    flex-wrap: wrap;
    height: auto;
    flex-direction: column;
    width: 54.4rem;
  }
`;

const TextInputOverride = styled(IndexedTextInput)`
  height: auto;

  .form-control {
    margin-bottom: 0;
    font-weight: bold;
    font-size: 1.6rem;
    line-height: 1.9rem;
    color: ${colors.darkBlue_darker};
    width: 23rem;
    margin-right: 3.5rem;
  }
`;

const ButtonContainer = styled.div`
  
  
`;

const SearchButton = styled(Button)`
  background: ${props => (props.isActive ? colors.darkBlue_darker : colors.darkBlue_lighter)};
  border: none;
  margin-right: 3.5rem;
  float: left;
`;

SearchContainer.propTypes = {
  searchDetails: PropTypes.object.isRequired,
  isActiveSearch: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onSearch: PropTypes.func,
  onAdd: PropTypes.func.isRequired,
  onSub: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  isActiveSave: PropTypes.bool.isRequired,
  isActiveAdd: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired
};

function SearchContainer({ searchDetails, isActiveSearch, isActiveSave, isActiveAdd, onAdd, onSub, onSave, onChange, onSearch, index }) {
  function emptyClick(){}
  function render() {
    return (
      <SearchContainerRow>
        <TextInputOverride
          name="from"
          index={index}
          placeholder="Leaving from?"
          value={searchDetails.from}
          onChange={onChange}
        />

        <TextInputOverride
          name="to"
          placeholder="Going to?"
          index={index}
          value={searchDetails.to}
          onChange={onChange}
        />

        <DatePicker
          name="departure"
          placeholder="Departure date"
          index={index}
          value={searchDetails.departure}
          onChange={onChange}
        />
        {index === 0 ? (
          <ButtonContainer>

        <SearchButton isActive={isActiveAdd} width={5} onClick={onAdd} >
        <FontAwesomeIcon icon={faPlus} color="white" />
            </SearchButton>
            
          <SearchButton isActive={isActiveSearch} width={5} onClick={onSearch}>
          <AppIcon name="search" />
        </SearchButton>

            <SearchButton isActive={isActiveSave} width={5} onClick={onSave}>
        <FontAwesomeIcon icon={faBookmark} color="white" />
            </SearchButton>
            </ButtonContainer>
        ) : (
          <ButtonContainer>

          <SearchButton isActive={searchDetails.last} width={5} onClick={searchDetails.last ? onSub : emptyClick} >
          <FontAwesomeIcon icon={faMinus} color="white" />
              </SearchButton>
              </ButtonContainer>
        )}
        
      </SearchContainerRow>
      
    );
  }

  return render();
}

export default SearchContainer;
